<template>
<div class="deliverylist">
    <div class="area-1290 mypurchase-order-main">
        <div class="controller-container">
            <div class="controller-content delivery-action-container">
                <el-cascader v-if="userTypeNum == 1 || userTypeNum == 0" class="action-select-inventory" placeholder="查看订货商" :filterable="true" :clearable="true" :options="oneLevelBuyerArr" v-model="oneLevelBuyer" @change="selectOneLevelBuyer"></el-cascader>
                <el-cascader v-if="userTypeNum == 0" class="action-select-inventory hide" placeholder="查看汽服门店" :filterable="true" :clearable="true" :options="twoLevelBuyerArr" v-model="twoLevelBuyer" @change="selectTwoLevelBuyer"></el-cascader>
                <el-button v-if="userTypeNum == 1 || userTypeNum == 0" class="action-select-inventory" @click="defautOrderList">查看所有订单</el-button>
                <el-button v-if="userTypeNum == 1" class="action-select-inventory" @click="myPurchaseOrder">我的进货配送</el-button>
                <el-button v-if="userTypeNum == 1 || userTypeNum == 0" class="action-select-inventory" @click="findFeiYouOrderDelivery">查看非油订单</el-button>
                <el-cascader v-if="isFeiyou && (userTypeNum == 0 || userTypeNum == 1)" class="action-select-inventory" placeholder="查看加油站" :filterable="true" :clearable="true" :options="stationArr" v-model="station" @change="selectStation"></el-cascader>
            </div>
        </div>
        <div class="table-container">
            <el-table v-if="!isFeiyou" :key="0" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle" :data="tableData" tooltip-effect="dark" style="width: 100%">
                <el-table-column prop="date" align="center" label="日期" width="160"></el-table-column>
                <el-table-column prop="buyer" align="center" label="订货商" width="160"></el-table-column>
                <el-table-column prop="send_address" align="center" label="发货厂" width="160"></el-table-column>
                <el-table-column prop="deliveryaddress" align="center" label="收货地址" width="160"></el-table-column>
                <el-table-column prop="status_name" align="center" label="配送状态" width="160"></el-table-column>
                <el-table-column prop="transport_express_user" align="center" label="配送员" width="160"></el-table-column>
                <el-table-column prop="duration" align="center" label="配送时长" width="100"></el-table-column>
                <el-table-column align="center" label="备注" width="360">
                    <template slot-scope="scope">
                        <!-- <span>这笔订单将于{{scope.row.estimate_duration}}送达</span> -->
                        <span v-if="scope.row.warehouse_type == 3">这笔订单将于{{scope.row.estimate_duration}}送达</span>
                    </template>
                </el-table-column>
                <el-table-column prop="logistics_number" align="center" label="物流单号" width="160"></el-table-column>
                <el-table-column prop="order_num" align="center" label="订单号" width="160"></el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="280">
                    <template slot-scope="scope">
                        <el-button @click="goOrderDetail(scope.row)" :disabled="false" type="text" size="small">订单详情</el-button>
                        <el-button @click="startDeliveryHandle(scope.row)" :disabled="scope.row.startDelivery" type="text" size="small">开始配送</el-button>
                        <el-button @click="goDeliveryTrail(scope.row)" :disabled="scope.row.deliveryTrail" type="text" size="small">配送轨迹</el-button>
                        <el-button type="text" @click="getGoodsOkHandle(scope.row)" :disabled="scope.row.getGoodsOk" size="small">确认收货</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 非油 -->
            <el-table v-else :key="1" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle" :data="tableData" tooltip-effect="dark" style="width: 100%">
                <el-table-column prop="date" align="center" label="日期" width="160"></el-table-column>
                <el-table-column prop="buyer" align="center" label="订货商" width="160"></el-table-column>
                <el-table-column prop="send_address" align="center" label="发货厂" width="160"></el-table-column>
                <el-table-column prop="deliveryaddress" align="center" label="收货地址" width="160"></el-table-column>
                <el-table-column prop="status_name" align="center" label="配送状态" width="160"></el-table-column>
                <el-table-column prop="transport_express_user" align="center" label="配送员" width="160"></el-table-column>
                <el-table-column prop="duration" align="center" label="配送时长" width="100"></el-table-column>
                <el-table-column align="center" label="备注" width="360">
                    <template slot-scope="scope">
                        <!-- <span>这笔订单将于{{scope.row.estimate_duration}}送达</span> -->
                        <span v-if="scope.row.warehouse_type == 3">这笔订单将于{{scope.row.estimate_duration}}送达</span>
                    </template>
                </el-table-column>
                <el-table-column prop="logistics_number" align="center" label="物流单号" width="160"></el-table-column>
                <el-table-column prop="order_num" align="center" label="订单号" width="160"></el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="120">
                    <template slot-scope="scope">
                        <!-- <el-button @click="goOrderDetail(scope.row)" :disabled="false" type="text" size="small">订单详情</el-button> -->
                        <!-- <el-button @click="startDeliveryHandle(scope.row)" :disabled="scope.row.startDelivery" type="text" size="small">开始配送</el-button> -->
                        <el-button @click="goDeliveryTrail(scope.row, true)" :disabled="scope.row.deliveryTrail" type="text" size="small">配送轨迹</el-button>
                        <!-- <el-button type="text" @click="getGoodsOkHandle(scope.row)" :disabled="scope.row.getGoodsOk" size="small">确认收货</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
    <!-- 模态框  -->
    <div class="dialog-group">
        <el-dialog title="收货地址" :visible.sync="dialogFormVisible">
            <el-form>
                <el-form-item label="活动区域" :label-width="formLabelWidth">
                    <el-select v-model="deliveryManIndex" placeholder="请选择配送员">
                        <el-option v-for="(item, index ) in deliveryManArr" :key="index" :label="item.name" :value="index"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="selectDeliveryManQuit">取 消</el-button>
                <el-button type="primary" @click="selectDeliveryManOk">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import {
    setTimeout
} from 'timers';
import Tool from '../../assets/js/Tool.js'
export default {
    data() {
        return {
            // stationArr  station  selectStation
            style: '',
            tableData: [],
            stationArr: [],
            currentBuyerId: '',
            oneLevelBuyerArr: [],
            twoLevelBuyerArr: [],
            oneLevelBuyer: [],
            station: [],
            twoLevelBuyer: [],
            isFeiyou: false,
            // startDelivery: true,
            // deliveryTrail: true,
            // getGoodsOk: true,
            deliveryManIndex: '',
            deliveryManArr: [],
            dialogFormVisible: false,
            formLabelWidth: '80px',
            currentOrderObj: {}
        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    created() {
        this.$nextTick(() => {
            this.init();
        })
    },
    methods: {
        changeTableHeaderStyle({
            row,
            rowIndex
        }) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (columnIndex == 1) {

            }
            return 'color: #000;'
        },
        async init() {
            if (this.userTypeNum == 2) {
                let tableData = await this.defautOrderList()
                this.tableData = this.changeOperatorStaus(tableData);
                // this.getOrderData(1, res => {
                //     this.tableData = this.changeOperatorStaus(res.data.data);
                // });
            } else {
                if (this.userTypeNum == 0) {
                    this.getBuyerStructure(1, () => {
                        this.getBuyerStructure(2, async () => {
                            let tableData = await this.defautOrderList()
                            this.tableData = this.changeOperatorStaus(tableData);
                            this.axios.get('express_user')
                            .then(res => {
                                this.deliveryManArr = res.data.data;
                            })
                            // this.getOrderData(2, res => {
                            //     this.tableData = this.changeOperatorStaus(res.data.data);
                                // this.axios.get('express_user')
                                //     .then(res => {
                                //         this.deliveryManArr = res.data.data;
                                //     })
                            // }, this.currentBuyerId);
                        })
                    })
                }if(this.userTypeNum == 3) {
                    this.isFeiyou = true;
                    this.axios.get('default_station_transport?user_id=' + this.user.id)
                    .then(res => {
                        if(res.data.status != 1) {
                            this.$message({
                                type: 'error',
                                message: res.data.msg
                            })
                            return;
                        }
                        else {
                            this.tableData = res.data.data;
                        }
                    })
                } else {
                    this.getBuyerStructure(1, async () => {
                        let tableData = await this.defautOrderList()
                        this.tableData = this.changeOperatorStaus(tableData);
                        this.axios.get('express_user')
                        .then(res => {
                            this.deliveryManArr = res.data.data;
                        })
                        // this.getOrderData(2, res => {
                        //     this.tableData = this.changeOperatorStaus(res.data.data);
                        //     this.axios.get('express_user')
                        //     .then(res => {
                        //         this.deliveryManArr = res.data.data;
                        //     })
                        // },this.currentBuyerId)
                    })
                }
            }
        },
        async findFeiYouOrderDelivery() {
            this.isFeiyou = true;
            let stationList = await this.axios.get('station_list?user_id=' + this.user.id);
            this.stationArr = stationList.data.data;
            // let fieyouOrderData = await this.axios.get('station_transport_list')
        },
        // defautOrderList
        async defautOrderList() {
            this.isFeiyou = false;
            let requestConfig = {
                url: 'all_transport_list?user_id=' + this.user.id,
                method: 'get'
            }
            let resData = await this.axios(requestConfig)
            return resData.data.data;
        },
        // 修正操作状态
        changeOperatorStaus(tableData) {
            tableData.forEach(item => {
                item.startDelivery = true;
                item.deliveryTrail = true;
                item.getGoodsOk = true;
            });

            tableData.forEach(row => {
                if (row.order_type_num == 1) {
                    if (this.userTypeNum == 0) {
                        if (this.user.id == row.check_user_id && row.status < 5) {
                            row.startDelivery = false;
                        }
                        if (row.status >= 5) {
                            row.deliveryTrail = false;
                        }
                        row.getGoodsOk = true;
                    } else if (this.userTypeNum == 1) {
                        if (row.status >= 5) {
                            row.deliveryTrail = false;
                        }
                        if (row.get_goods_user_id == this.user.id && row.status < 6) {
                            row.getGoodsOk = false;
                        }
                        row.startDelivery = true;
                    }
                } else if (row.order_type_num == 0) {
                    if (this.userTypeNum == 1) {
                        if (this.user.id == row.check_user_id && row.status < 2) {
                            row.startDelivery = false;
                        }
                        if (row.status >= 2) {
                            row.deliveryTrail = false;
                        }
                        row.getGoodsOk = true;
                    } else if (this.userTypeNum == 2) {
                        if (row.get_goods_user_id == this.user.id && row.status < 3) {
                            row.getGoodsOk = false;
                        }
                        if (row.status >= 2) {
                            row.deliveryTrail = false;
                        }
                        row.startDelivery = true;
                    }
                }
            });
            return tableData;
        },
        // 获取订货商
        getBuyerStructure(type, callback) {
            this.axios.get('branch_in', {
                    params: {
                        type: type,
                        user_id: this.user.id
                    }
                })
                .then(res => {
                    if (this.userTypeNum == 0) {
                        if (type == 1) {
                            this.oneLevelBuyerArr = res.data.data;
                            // this.currentBuyerId = this.oneLevelBuyerArr[0].value;
                        } else if (type == 2) {
                            this.twoLevelBuyerArr = res.data.data;
                        }
                    } else if (this.userTypeNum == 1) {
                        this.oneLevelBuyerArr = res.data.data;
                        // this.currentBuyerId = this.oneLevelBuyerArr[0].value;
                    }
                    if ((typeof callback) == 'function') {
                        callback();
                    }
                })
        },
        async selectStation() {
            console.log('this.station: ', this.station);
            let station_id ;
            if(this.userTypeNum == 0) {
                station_id = this.station[1];
            }
            else if(this.userTypeNum == 1) {
                station_id = this.station[0];
            }
            let tableData = await this.axios.get('station_transport_list?station_id='+ station_id);
            this.tableData = tableData.data.data;
            console.log('this.tableData: ', this.tableData);
        },
        // 请求配送订单数据
        getOrderData(style, callback, buyerId) {
            if (buyerId) {
                var sendArg = {
                    user_id: this.user.id,
                    style: style,
                    id: buyerId
                }
            } else {
                var sendArg = {
                    user_id: this.user.id,
                    style: style
                }
            }
            this.axios.get('transport_list', {
                    params: sendArg
                })
                .then(res => {
                    callback(res);
                })
        },
        // 我的进货配送
        myPurchaseOrder() {
            this.isFeiyou = false;
            this.getOrderData(1, res => {
                this.tableData = this.changeOperatorStaus(res.data.data);
            })
        },
        // 选择一级进货商
        selectOneLevelBuyer(value) {
            this.isFeiyou = false;
            this.currentBuyerId = value[0];
            this.getOrderData(2, res => {
                this.tableData = this.changeOperatorStaus(res.data.data);
                console.log(JSON.stringify(this.tableData));
            }, this.currentBuyerId);
        },
        // 选择二级进货商
        selectTwoLevelBuyer(value) {
            this.isFeiyou = false;
            this.currentBuyerId = value[1];
            this.getOrderData(2, res => {
                this.tableData = this.changeOperatorStaus(res.data.data);
            }, this.currentBuyerId);
        },
        // 选择配送员
        selectDeliveryManOk() {
            this.currentOrderObj.transport_express_user = this.deliveryManArr[this.deliveryManIndex].name;
            this.dialogFormVisible = false;
            this.$message({
                'type': 'success',
                'message': '选择配送员成功！'
            });
            setTimeout(() => {
                this.$notify.info({
                    title: '消息',
                    duration: 5000,
                    message: '请再次点击开始配送，您的订单将马上开始为您配送！'
                })
            }, 1500)
        },
        selectDeliveryManQuit() {
            this.deliveryManIndex = '';
            this.dialogFormVisible = false;
        },
        // 开始配送
        startDeliveryHandle(rowData) {
            this.currentOrderObj = rowData;
            // alert(this.deliveryManIndex)
            //  && this.userTypeNum == 1
            
            if (this.userTypeNum == 1) {
                if (this.deliveryManIndex === '') {
                    this.dialogFormVisible = true;
                    return;
                }
                var sendObj = {
                    oid: rowData.id,
                    logistics_number: Tool.getUniqueRandom(),
                    // transport_id: this.deliveryManArr[this.deliveryManIndex].id
                    transport_id: rowData.transport_id,
                    express_user_id: this.deliveryManArr[this.deliveryManIndex].id
                }
            }
            if (this.userTypeNum == 0) {
                if(rowData.warehouse_type == 4) {
                    if (this.deliveryManIndex === '') {
                        this.dialogFormVisible = true;
                        return;
                    }
                    var sendObj = {
                        oid: rowData.id,
                        logistics_number: Tool.getUniqueRandom(),
                        transport_id: rowData.transport_id,
                        express_user_id: this.deliveryManArr[this.deliveryManIndex].id
                    }
                }
                else {
                    var sendObj = {
                        oid: rowData.id,
                        logistics_number: Tool.getUniqueRandom(),
                        transport_id: rowData.transport_id,
                        // express_user_id: this.deliveryManArr[this.deliveryManIndex].id
                    }
                }
            }

            this.axios.post('update_transport', JSON.stringify(sendObj))
                .then(res => {
                    this.deliveryManIndex = '';
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    rowData.startDelivery = true;
                })
        },
        getGoodsOkHandle(rowData) {
            this.axios.get('gain_good', {
                    params: {
                        oid: rowData.id
                    }
                })
                .then(res => {
                    this.$message({
                        type: 'success',
                        message: '确认收货！'
                    });
                    rowData.getGoodsOk = true;
                })
        },
        goOrderDetail(rowData) {
            let routeData = this.$router.resolve({
                name: 'orderdetaillook',
                query: {
                    oid: rowData.id,
                    user: JSON.stringify(this.user)
                }
            })
            window.open(routeData.href, '_blank');
        },
        goDeliveryTrail(rowData, isFeiYou) {
            if(isFeiYou) {
                let routeData = this.$router.resolve({
                    name: 'deliverytrail',
                    query: {
                        oid: rowData.id,
                        isFeiYou: 'yes',
                        user: JSON.stringify(this.user)
                    }
                })
                window.open(routeData.href, '_blank');
                return;
            }
            if(rowData.warehouse_type != 4) {
                
                let routeData = this.$router.resolve({
                    name: 'deliverytrail',
                    query: {
                        oid: rowData.id,
                        user: JSON.stringify(this.user)
                    }
                })
                window.open(routeData.href, '_blank');
            }
            else {
                this.$router.push({
                    name: 'deliverytrail',
                    query: {
                        oid: rowData.id,
                        isWarehouseSend: true,
                        user: JSON.stringify(this.user)
                    }
                })
            }
            
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.deliverylist {
    position: relative;
    /* padding-bottom: 400px; */
}

.mypurchase-order-main {
    position: relative;
}

.delivery-action-container {
    position: absolute;
    top: -58px;
    left: 215px;
    width: 900px;
    height: 45px;
    margin: 0 auto;
    padding-top: 5px;
    padding-left: 16px;
}

.action-select-first,
.action-select-inventory {
    margin-left: 24px;
    width: 133px;
}

.action-select-first {
    margin-left: 0px;
}

.controller-container .el-button {
    color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/pages/deliveryManage/DeliveryList.vue